
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ResponsiveContainer extends Vue {
  @Prop({ type: String, default: '12' }) readonly cols!: string;

  @Prop({ type: String, default: '8' }) readonly sm!: string;

  @Prop({ type: String, default: '6' }) readonly md!: string;

  @Prop({ type: String, default: '5' }) readonly lg!: string;

  @Prop({ type: String, default: '4' }) readonly xl!: string;
}
